import { Icon } from '@livable/saas-react-components';
import { Chip, Typography } from '@mui/material';
import React from 'react';
// import { useTranslation } from 'react-i18next';
import useAllocationUtilityStyles from 'src/pages/AllocationTablesPage/AllocationUtility/styles';
import { UtilityCredentialItem } from 'src/components/shared/UtilityCredentialItem';

// ! move to src/pages/AllocationTablesPage/AllocationUtility/UtilityCredential/index.jsx
// ? i18n
const UtilityCredential = () => {
  const classes = useAllocationUtilityStyles();
  // const { t } = useTranslation();

  const utilityCredential = {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.groupWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Auto-billing credentials"), /*#__PURE__*/React.createElement(Typography, {
    marginBottom: "16px",
    variant: "body"
  }, "The auto-billing for this utility is activated. Bill frequency is ", /*#__PURE__*/React.createElement("b", null, "monthly"), ". Please use the credentials listed below to get the billing information."), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityCredentialItemChip
  }, /*#__PURE__*/React.createElement(Chip, {
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "WARNING! These credentials are highly confidential. Do NOT share or display them to anyone. Unauthorized disclosure may compromise security. Handle with care."),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    variant: "warning"
  })), /*#__PURE__*/React.createElement(UtilityCredentialItem, {
    credentialData: utilityCredential,
    key: 'UtilityCredentialItem_' + utilityCredential.id
  }));
};
export default UtilityCredential;